import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class ComissoesClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async findAll(params = {}) {
    try {
      const { data } = await this.api.get('/relatorios/findAll', { params });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar dados do relatório de comissões');
    }
  }

  async gerarPdfComissoes(params = {}) {
    try {
      return await this.api.get('/relatorios/pdf/gerarPdfComissoes', {
        params,
        responseType: 'blob',
      });
    } catch (error) {
      console.error(error, 'Erro ao gerar PDF de comissões');
      throw this.error.message(error, 'Erro ao gerar PDF do relatório de comissões');
    }
  }
}
